/** Padrão de paginação para listagens com filtros (evita carga excessiva na API). */
export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [20, 50, 100, 500, 1000];

/** Filtro lista completa vs favoritos — padrão exibir todos os registros. */
export const DEFAULT_LISTA_TIPO = 'todos';
